module.exports = __webpack_public_path__ + "static/media/Runway09.7cbf705f.glb";